import type {
  PieceStepMetadata,
  StepMetadata,
} from '@/features/pieces/lib/types';
import {
  ActionType,
  ADVANCED_CORE_ACTIONS,
  ADVANCED_PIECE_NAMES,
  TenantPolicy,
  TriggerType,
} from '@activepieces/shared';

import { policyHooks } from './policy-hooks';

export { ADVANCED_CORE_ACTIONS, ADVANCED_PIECE_NAMES };

export const isPieceLockedForPolicy = (
  metadata: StepMetadata,
  policy: TenantPolicy | undefined,
): boolean => {
  if (!policy || policy.advancedPiecesEnabled) return false;
  if (
    metadata.type === ActionType.PIECE ||
    metadata.type === TriggerType.PIECE
  ) {
    return ADVANCED_PIECE_NAMES.has(
      (metadata as PieceStepMetadata).pieceName,
    );
  }
  return ADVANCED_CORE_ACTIONS.has(metadata.type);
};

export const useIsPieceLocked = (
  metadata: StepMetadata | undefined,
): boolean => {
  const { data: policy } = policyHooks.usePolicy();
  if (!metadata) return false;
  return isPieceLockedForPolicy(metadata, policy);
};
